const colors = {
  primary900: '#014BB0',
  primary800: '#065BC2',
  primary700: '#0C6CD5',
  primary: '#117CE7',
  primary500: '#00A8F0',
  primary400: '#1EB5F5',
  primary300: '#31C1F2',
  primary200: '#75D3F5',
  primary100: '#ADE5F9',
  primary50: '#DFF5FD',

  secondary900: '#E98500',
  secondary800: '#EC9418',
  secondary700: '#EFA331',
  secondary: '#F2B249',
  secondary500: '#F5C161',
  secondary400: '#F5CD6B',
  secondary300: '#F5E292',
  secondary200: '#F5E89F',
  secondary100: '#F9F0C7',
  secondary50: '#FDF4DB',

  gray900: '#252729',
  gray800: '#46494B',
  gray700: '#66686B',
  gray600: '#7A7D7F',
  gray500: '#A4A6A9',
  gray400: '#C2C4C8',
  gray300: '#E4E7EA',
  gray200: '#EFF2F5',
  gray100: '#F4F7FA',
  gray50: '#F9FBFF',

  background: 'rgb(190,191,192,0.12)',

  white07: 'rgb(255,255,255,0.7)',
  white15: 'rgb(255,255,255,0.15)',
  white33: 'rgb(255,255,255,0.33)',
  white70: 'rgb(255,255,255,0.7)',

  strong: '#171717',
  normal: 'rgb(23,23,23,0.87)',
  toast: 'rgb(23,23,23,0.78)',
  assistive: 'rgb(23,23,23,0.7)',
  supportive: 'rgb(23,23,23,0.4)',
  disabled: 'rgb(23,23,23,0.15)',

  fill20: 'rgb(23,23,23,0.2)',
  fill12: 'rgb(23,23,23,0.12)',
  fill05: 'rgb(23,23,23,0.05)',
  fill03: 'rgb(23,23,23,0.03)',
  fill02: 'rgb(23,23,23,0.02)',

  alert: '#F14841',
  alertHover: '#CF2922',
  alertFocus: '#C62721',
  warning: '#FBB54A',
  success: '#3CCB39',

  dustRed: '#FF3B30',
  dustYellow: '#FFCC00',
  dustGreen: '#34C759',
  dustBlue: '#32ADE6',
};

const background = {
  day: '#318DEE',
  night: '#34466E',
  clearDay: '#3A90ED',
  clearNight: '#3C4F78',
  cloudyDay: '#3883EC',
  cloudyNight: '#374A73',
  grayDay: '#646475',
  grayNight: '#48425F',
  snowyDay: '#738393',
  snowyNight: '#455868',
  rainyDay: '#676B6E',
  rainyNight: '#52545C',
  dust: '#7D7570',
};

const shadows = {
  elevation01: '0px 1px 4px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation02: '0px 2px 6px 1px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation03: '0px 3px 8px 2px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation04: '0px 3px 10px 2px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation05: '0px 4px 10px 3px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation06: '0px 4px 10px 4px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  effect: '0px 0px 5px 0px rgba(4, 31, 72, 0.40)',
};

const device = {
  small: 'only screen and (max-width: 359px)',
};

export const theme = {
  colors,
  background,
  shadows,
  device,
};
